import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UserController from "../../../../services/system/user/user-controller";
import CampaignController from "../../../../services/qlts/campaign-controller";
import {getSchoolYear} from "../../../../utils/authority";

class modalCreateAdmissions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            description: '',
            link: '',
            name: '',
            sourceCampaign: 'NONE',
            showBlock: true,
            signupInfo: null
        };
    }

    createCampaign = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            "description": this.state.description,
            "link": this.state.link,
            "name": this.state.name,
            "sourceCampaign": this.state.sourceCampaign
        }
        CampaignController.create(payload, res => {
            if (res.success) {
                toast.success("Thêm chiến dịch thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.warning("Lỗi: "+res.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Thêm mới chiến dịch tuyển sinh</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Tên chiến dịch(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        placeholder="QC Times"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.state.name}
                                        onChange={(event) => {
                                            this.setState({
                                                name: event.target.value
                                            })
                                        }}
                                    />
                                </div>

                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Mô tả chiến dịch(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        placeholder="Nam/Nữ: 30-60 Tuổi"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.state.description}
                                        onChange={(event) => {
                                            this.setState({
                                                description: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Link LandingPage(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        placeholder="Nhập link trang tuyển sinh"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.state.link}
                                        onChange={(event) => {
                                            this.setState({
                                                link: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Loại chiến dịch(<span  style={{color: "red",}}>*</span>)</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.sourceCampaign}
                                        onChange={(e) => {
                                            this.state.sourceCampaign = e.target.value;
                                            this.setState({
                                                sourceCampaign: e.target.value
                                            })
                                        }}
                                    >
                                        <option value="NONE">Chọn loại chiến dịch</option>
                                        <option value="FACEBOOK">Facebook</option>
                                        <option value="YOUTUBE">Youtube</option>
                                        <option value="TIKTOK">Tiktok</option>
                                        <option value="GOOGLE">Google</option>
                                        <option value="OTHER">Khác</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.createCampaign()}
                                >
                                        <span className='justify-content-center'>
                                            Đồng ý
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>


                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default modalCreateAdmissions
